import _ from 'lodash'
import vm from '../main'
import { httpClient as http } from '../services'
import config from "../config";
import axios from 'axios'
const internals = {}

internals.dutyMonitoring = function (params) {
  let parameters = ''
  if (params.page !== undefined) {
    parameters += `&page=${params.page}`;
  }
  if (params.limit !== undefined) {
    parameters += `&limit=${params.limit}`;
  }
  if (params.cityId !== undefined) {
    parameters += `&cityId=${params.cityId}`;
  }
  // let parameters = `?type=all&page=${params.page}&limit=${params.limit}&cityId=${params.cityId}`
  if (params.sortBy !== undefined) {
    parameters += `&sortBy=${params.sortBy}`;
    parameters += `&sortOrder=${params.sortOrder}`;
  }
  if (params.searchString !== undefined) {
    parameters += `&searchString=${params.searchString}`;
  }
  parameters = parameters ? `?type=all${parameters}` : '';
  return http
    .get(`trip/location-tracker/location${parameters}`)
    .then(result => {
      return result
    })
    .catch(error => {
      console.error('srveyorService.inviteUser-error:\n', error)
      throw error
    })
}

internals.tripMonitoring = function (params) {
  let parameters = `?page=${params.page}&limit=${params.limit}&cityId=${params.cityId}`;
  if (params.sortBy) {
    parameters += `&sortBy=${params.sortBy}`;
    parameters += `&sortOrder=${params.sortOrder}`;
  }
  if (params.searchString) {
    parameters += `&searchString=${params.searchString}`;
  }
  return http
    .get(`vehicle-monitor/list${parameters}`)
    .then(result => {
      return result
    })
    .catch(error => {
      console.error('trackingService.inviteUser-error:\n', error)
      throw error
    })
}

internals.getTraccarToken = function () {
  return http
    .get(`traccarToken`)
    .then(result => {
      return result
    })
    .catch(error => {
      console.error('trackingService.inviteUser-error:\n', error)
      throw error
    })
}
internals.getsuperAdminToken = function () {
  return http
    .get(`superAdminTraccarToken`)
    .then(result => {
      return result
    })
    .catch(error => {
      console.error('trackingService.inviteUser-error:\n', error)
      throw error
    })
}

internals.locationById = function (id) {
  return http
    .get(`trip/location-tracker/getLatest/${id}`)
    .then(result => {
      return result
    })
    .catch(error => {
      console.error('trackingService.inviteUser-error:\n', error)
      throw error
    })
}

internals.vehicleMoniter = function (id) {
  return http
    .get(`vehicleUserTraccarToken?vehicleId=${id}`)
    .then(result => {
      return result
    })
    .catch(error => {
      console.error('vehicleUserTraccarTokenService.inviteUser-error:\n', error)
      throw error
    })
}


internals.traccarMonitoring = function (params) {
  let parameters = ''
  if (params.cityId !== undefined) {
    parameters += `cityId=${params.cityId}`;
  }
  if (params.date !== undefined && params.date != "") {
    parameters += `&date=${params.date}`;
  }

  return http
    .get(`/trip/gohead-driver/tracarr-dashboard-zone-list?${parameters}`)
    .then(result => {
      return result
    })
    .catch(error => {
      console.error('srveyorService.inviteUser-error:\n', error)
      throw error
    })
}

internals.traccarMonitoringTripDetails = function (params) {
  let parameters = ''
  if (params.zoneId !== undefined) {
    parameters += `${params.zoneId}`;
  }

  return http
    .get(`/trip/primary-trip/for-traccarr/${parameters}`)
    .then(result => {
      return result
    })
    .catch(error => {
      console.error('srveyorService.inviteUser-error:\n', error)
      throw error
    })
}


internals.traccarMonitoringSession = function (params) {
  const originalAuthorizationHeader = axios.defaults.headers.common.Authorization;
  delete axios.defaults.headers.common.Authorization;
  let parameters = ''
  if (params.token !== undefined) {
    parameters += `token=${params.token}`;
  }
  if (params.getDateTime !== undefined) {
    parameters += `&t=${params.getDateTime}`;
  }
  try {
    return axios.get(`https://${config.Traccar_URI}api/session?${parameters}`)
      .then(result => {
        return result
      })
      .catch(error => {
        console.error('srveyorService.inviteUser-error:\n', error)
        throw error
      })
  }
  catch (error) {

  } finally {
    axios.defaults.headers.common.Authorization = originalAuthorizationHeader;
  }
}


internals.traccarMonitoringDeviceData = function (params) {
  const originalAuthorizationHeader = axios.defaults.headers.common.Authorization;
  delete axios.defaults.headers.common.Authorization;
  let parameters = ''
  // if (params.token !== undefined) {
  //   parameters += `token=${params.token}`;
  // }
  // if (params.getDateTime !== undefined) {
  //   parameters += `&t=${params.getDateTime}`;
  // }
  // console.log('parameters', parameters)
  // https://
  // dev.wms.goaheadtechnologies.in/traccar/
  try {
    return axios.get(`https://${config.Traccar_URI}api/devices`)
      .then(result => {
        return result
      })
      .catch(error => {
        console.error('traccarMonitoringDeviceData.inviteUser-error:\n', error)
        throw error
      })
  }
  catch (error) {

  } finally {
    axios.defaults.headers.common.Authorization = originalAuthorizationHeader;
  }
}




// https://api.dev.wms.goaheadtechnologies.in/reports/positions?from=2023-06-29T11:37:07.980Z&to=2023-07-23T11:39:34.108Z&traccarId=36
internals.traccarMonitoringPreviousData = function (params) {
  let parameters = ''
  if (params.fromDate !== undefined) {
    parameters += `from=${params.fromDate}`;
  }
  if (params.toDate !== undefined) {
    parameters += `&to=${params.toDate}`;
  }
  if (params.traccarId !== undefined) {
    parameters += `&traccarId=${params.traccarId}`;
  }

  return http
    .get(`/reports/positions?${parameters}`)
    .then(result => {
      return result
    })
    .catch(error => {
      console.error('srveyorService.inviteUser-error:\n', error)
      throw error
    })
}

internals.updateCollectedLinesStatus = tripId => {
  return http
 .post('/trip/primary-trip/update/collected-lines', {
        tripId: tripId.tripId,
        lineNumbers: tripId.lineNumbers        
      })
      .then(result => {
          tripId = result.data
        return result
      })
      .catch(error => {
        console.error('trackingService.primarytrip-update-lines-error:\n', error)
        throw error
      })
}

export default internals


// WEBPACK FOOTER //
// ./src/services/tracking.service.js